<template>
  <section id="faq" class="n2-seccion n2-seccion--suave" v-if="F?.Mostrar && preguntas.length">
    <div class="n2-contenedor n2-dos-columnas n2-dos-columnas--faq">
      <div class="n2-aparece">
        <h2 class="n2-titulo-seccion" v-html="F.Titulo?.Texto"></h2>
        <div v-if="F.Descripcion?.Texto" class="n2-entradilla" :style="alineacionTexto(F.Descripcion.css)" v-html="F.Descripcion.Texto"></div>
      </div>
      <div class="n2-faq">
        <details v-for="(p, i) in preguntas" :key="i" class="n2-aparece" :open="i === 0">
          <summary v-html="p.Pregunta"></summary>
          <div class="n2-texto-rico" v-html="p.Respuesta"></div>
        </details>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { alineacionTexto } from '../../composables/useNotaria2'
const store = useStore()
const { NOTARIA } = storeToRefs(store)
// Panel: Inicio → Preguntas frecuentes
const F = computed(() => NOTARIA.value?.Theme?.Home?.FAQ)
const preguntas = computed(() => NOTARIA.value?.FAQs ?? [])
</script>
